var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 7.5001L7.19103 15.4407C6.93249 15.7261 6.79358 16.0999 6.80306 16.4848C6.81254 16.8697 6.96968 17.2363 7.24194 17.5086C7.51421 17.7808 7.88076 17.938 8.26568 17.9474C8.65061 17.9569 9.02445 17.818 9.30978 17.5595L18.6192 8.11885C19.1362 7.54817 19.4141 6.80051 19.3951 6.03065C19.3761 5.26079 19.0619 4.52771 18.5173 3.98317C17.9728 3.43864 17.2397 3.12436 16.4699 3.1054C15.7 3.08645 14.9523 3.36427 14.3817 3.88135L5.07228 13.322C4.22939 14.1649 3.75586 15.3081 3.75586 16.5001C3.75586 17.6921 4.22939 18.8353 5.07228 19.6782C5.91517 20.5211 7.05838 20.9946 8.25041 20.9946C9.44244 20.9946 10.5856 20.5211 11.4285 19.6782L19.1254 12.0001",
    stroke: "#147F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.9166795acdd3a32aba7022f8ba09510e.svg";
export { ForwardRef as ReactComponent };